import { 
  GET_ANALYTICS_STICKY_COLUMNS,
  GET_ANALYTICS_STICKY_COLUMNS_ERROR,
  GET_ANALYTICS_STICKY_COLUMNS_SUCCESS,
  UPDATE_ANALYTICS_STICKY_COLUMNS,
  UPDATE_ANALYTICS_STICKY_COLUMNS_ERROR,
  UPDATE_ANALYTICS_STICKY_COLUMNS_SUCCESS,
} from "./actionTypes"

const initialState = {
  error: null,
  user_column_preference_analytic: null,
  loading: false
}

const UserAnalyticsColumnPreference = (state = initialState, action) => {
  switch (action.type) {
    case GET_ANALYTICS_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case GET_ANALYTICS_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_analytic: action.payload,
        loading: false
      }

    case GET_ANALYTICS_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_ANALYTICS_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case UPDATE_ANALYTICS_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_analytic: action.payload,
        loading: false
      }

    case UPDATE_ANALYTICS_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    default:
      return state
  }
}

export default UserAnalyticsColumnPreference;
